module.exports = __webpack_public_path__ + "static/media/img.acd2940e.png";